import { useCallback } from 'react';

function useOpenApp(isProd = true, slug?: string) {
  return useCallback(() => {
    if (!window) {
      console.warn('window is not defined, are you running this in a browser?');
      return;
    }
    const url = isProd ? 'org.athletes.app://' : 'org.athletesdev.app://';

    window.location.replace(url);
  }, []);
}

export default useOpenApp;
